import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const LoadingSpinner = ({ className }) => {
    return (
        <div className={clsx('m2g-loading', className)}>
            <span className="m2g-icon m2g-icon--spinner" />
        </div>
    );
};

LoadingSpinner.propTypes = {
    className: PropTypes.string,
};

LoadingSpinner.defaultProps = {
    className: null,
};

export default LoadingSpinner;
